import React, { useEffect, useState } from "react";
import { useNavigate, useSearchParams } from "react-router-dom";

import { getPetsPaginated } from "../services/api";
import { getFiltersIcon } from "../services/icons";
import { FilterValueUpdateType, PetAPIResponseType, SearchParamsType } from "../types";
import Button from "./Button";
import DogCard from "./DogCard";
import Dropdown from "./Dropdown";
import PetFilter from "./PetFilter";
import PetGrid from "./PetGrid";
import SideBar from "./SideBar";

const defaultSearchParams = {
  lastId: "",
  page: 1,
  perPage: 8,
};

export default function PetList({ showFilter = true, gridWrapperCss = "" }) {
  const [loading, setLoading] = useState(true);
  const [queryParams, setQueryParams] = useSearchParams();
  const [searchParams, setSearchParams] = useState<SearchParamsType>();
  const [total, setTotal] = useState<number>(0);
  const [lastId, setLastId] = useState("");
  const [pets, setPets] = useState([] as PetAPIResponseType[]);

  useEffect(() => {
    const pagePrm = queryParams.get("page");
    const perPagePrm = queryParams.get("perPage");
    const genderParam = queryParams.get("gender");
    const sizeParam = queryParams.get("size");
    const countryParam = queryParams.get("country");

    const pr: SearchParamsType = {
      ...defaultSearchParams,
      page: pagePrm ? parseInt(pagePrm) : defaultSearchParams.page,
      perPage: perPagePrm ? parseInt(perPagePrm) : defaultSearchParams.perPage,
    };

    if (genderParam) {
      pr.gender = genderParam;
    }

    if (sizeParam) {
      pr.size = sizeParam;
    }

    if (countryParam) {
      pr.country = countryParam;
    }

    setSearchParams(pr);

    void fetchDogs(pr);
  }, []);

  useEffect(() => {
    console.log("searchParams", searchParams);
    if (!searchParams) {
      return;
    }

    setQueryParams(() => {
      const { page, perPage, lastId, ...rest } = searchParams;

      const spms = Object.entries(rest).reduce((acc, entry) => {
        const [key, value] = entry;
        if (value !== "") {
          acc[key] = value;
        }
        return acc;
      }, {} as SearchParamsType);

      return spms;
    });
  }, [searchParams]);

  const fetchDogs = async (params: SearchParamsType, clear = false) => {
    if (!params) {
      // return;
    }
    try {
      await getPetsPaginated(params)
        .then((data) => {
          if (params.page === 1 || clear) {
            setPets([...data.items]);
          } else {
            setPets((prev) => [...prev, ...data.items]);
          }
          if (data.items.length > 0) {
            setLastId(data.items[data.items.length - 1].id);
          }
          if (data.total) {
            setTotal(data.total);
          }
        })
        .finally(() => {
          console.log("loaded");
          setLoading(false);
        });
    } catch (e) {
      console.log(e);
    }
  };

  const loadMore = () => {
    if (!searchParams || searchParams.page * searchParams.perPage >= total) {
      return;
    }

    const params = { ...searchParams };
    params.page = params.page + 1;
    params.lastId = lastId;
    setSearchParams(params);

    void fetchDogs(params);
  };

  const onFilterValueUpdate: FilterValueUpdateType = (name, value) => {
    const params = { ...searchParams, ...defaultSearchParams, [name]: value };
    setSearchParams(params);

    void fetchDogs(params, true);
  };

  if (loading || !searchParams) {
    return null;
  }

  return (
    <>
      <div className="relative mt-6 flex flex-col gap-5 px-5">
        {showFilter && (
          <PetFilter searchParams={searchParams} onFilterValueUpdate={onFilterValueUpdate} />
        )}
        <div className={gridWrapperCss}>
          {pets.length > 0 ? (
            <>
              <PetGrid pets={pets} total={total} />
              <div className="mb-8 flex flex-col items-center justify-center gap-3">
                <div className="font-simianregular leading-none text-[#A19D9D]">
                  <span className="text-[#0B0B0B]">{pets.length}</span> out of{" "}
                  <span className="text-[#0B0B0B]">{total}</span> dogs
                </div>
                <div className="relative w-[140px] rounded-full bg-[#EAE4E0]">
                  <div
                    className="h-[2px] rounded-full bg-black"
                    style={{
                      width: `${(pets.length / total) * 100}%`,
                    }}
                  />
                </div>
                <Button title="Load more" onClick={loadMore} size="medium" />
              </div>
            </>
          ) : (
            <>No dogs found.</>
          )}
        </div>
      </div>
    </>
  );
}
